import { match } from 'ts-pattern';

import type { OtpChannel } from '@Common/types/auth/otp_channel';

type TwoFactorOtpConfig =
  | { kind: 'otp'; type: 'sms' | 'email'; alternateEmail?: string }
  | { kind: 'contact_support' };

export function getTwoFactorOtpConfig(otpChannel: OtpChannel): TwoFactorOtpConfig {
  return match(otpChannel)
    .returnType<TwoFactorOtpConfig>()
    .with({ type: 'sms' }, () => ({ kind: 'otp', type: 'sms' }))
    .with({ type: 'alternate_email' }, ({ email }) => ({
      kind: 'otp',
      type: 'email',
      alternateEmail: email,
    }))
    .with({ type: 'primary_email' }, () => ({ kind: 'otp', type: 'email' }))
    .with({ type: 'unavailable' }, () => ({ kind: 'contact_support' }))
    .exhaustive();
}
